import { render, staticRenderFns } from "./IndicationsForm.vue?vue&type=template&id=4a9cc7c8"
import script from "./IndicationsForm.vue?vue&type=script&lang=js"
export * from "./IndicationsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports